import useFetch from "../../Hooks/useFetch";
import styles from "./assets/css/CoreValues.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useRef, useState } from "react";

const CoreValues = () => {
  const { data: coreValues, error } = useFetch("core_value");
  const [coreValuesFadeIn, setCoreValuesFadeIn] = useState(false);
  const [autoPlayOnEnter, setAutoPlayOnEnter] = useState(false);
  const coreValuesRef = useRef();

  if (coreValues) {
    coreValues.sort((a, b) => a.acf.order - b.acf.order);
  }

  useEffect(() => {
    if (!coreValuesRef.current) return;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setCoreValuesFadeIn(true);
          setAutoPlayOnEnter(true);
          document.body.style.backgroundColor = "white";
        } else {
          setCoreValuesFadeIn(false);
          document.body.style.backgroundColor = null;
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(coreValuesRef.current);
  }, [coreValues, coreValuesRef]);

  const settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 4000,
    centerPadding: "400px",
    className: "core-values-slider",
    lazyLoad: true,
    dotsClass: "core-values-dots",
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 1900,
        settings: {
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 1400,
        settings: {
          centerPadding: "150px",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "0px",
        },
      },
    ],
  };

  return (
    <div id="coreValues" ref={coreValuesRef}>
      <div className={styles.coreValuesContainer}>
        <h3>Our Core Values</h3>
        <p>
          Our main aim is to ensure that KYB has a strong presence in the
          Motorcross market and that every Offroad Motorcross fanatic recognizes
          KYB as the trustworthy premium brand it is.
        </p>
      </div>
      <section
        className={`${styles.coreValuesSection} ${
          coreValuesFadeIn && styles.coreValuesFadeIn
        }`}
      >
        {error ? (
          <p className={styles.errorMessage}>Error Loading Core Values</p>
        ) : (
          coreValues &&
          autoPlayOnEnter && (
            <Slider {...settings}>
              {coreValues.map((coreValue, index) => (
                <div key={index} className={styles.coreValue}>
                  <picture className={styles.image}>
                    <source
                      media="(min-width: 400px)"
                      srcSet={coreValue.acf.image.sizes.medium_large}
                      height={coreValue.acf.image.sizes["medium_large-height"]}
                      width={coreValue.acf.image.sizes["medium_large-width"]}
                    />
                    <img
                      className={styles.imageShadow}
                      src={coreValue.acf.image.sizes.large}
                      alt="Your Alt Text"
                    />
                  </picture>

                  <div className={styles.coreValuesText}>
                    <h4
                      className={styles.title}
                      dangerouslySetInnerHTML={{
                        __html: coreValue.title.rendered,
                      }}
                    ></h4>
                    <div
                      className={styles.description}
                      dangerouslySetInnerHTML={{
                        __html: coreValue.acf.description,
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </Slider>
          )
        )}
      </section>
    </div>
  );
};
export default CoreValues;
